import React, { Component } from 'react';
import Table from '../table/table';
import TBody from '../table/tBody';
import Tr from '../table/tr';
import Td from '../table/td';
import ButtonTable from '../table/buttonTable';

export default class ListaAutoSuggestManual extends Component {
	state = {
		texto: '',
		sugestoes: []
	};

	onChange = e => {
		const texto = e.target.value;

		const sugestoes = texto 
            ? this.props.opcoes
                .filter(op => op.toLowerCase().includes(texto.toLowerCase()))
                .slice(0, 5)
            : [];

		this.setState({ texto, sugestoes });
	};

	adicionar = valor => {
		if (!valor) return;

		const listaAtual = this.props.lista || [];
        listaAtual.push({
            id: new Date().getTime(),
            descricao: valor,
			ativo: true
        });

		this.props.onChange(listaAtual);

		this.setState({ texto: '', sugestoes: [] });
	};

	remover = item => {

		let novaLista = [];

		if (item.datahora_inclusao) {
			novaLista = (this.props.lista || []).map(itemAux => {
				if (itemAux.id == item.id) {
					return {
						...itemAux,
						ativo: false
					};
				}

				return itemAux;
			});
		} else {
			novaLista = (this.props.lista || []).filter(itemAux => itemAux.id != item.id)
		}
		
		this.props.onChange(novaLista);
	};

	onKeyDown = e => {
		if (e.key === 'Enter') {
			e.preventDefault();
			this.adicionar(this.state.texto);
		}
	};

	render() {
		const lista = this.props.lista || [];

		return (
			<div>
				<div style={{ display: 'flex', gap: 5 }}>
					<input
						className='form-control'
						value={this.state.texto}
						onChange={this.onChange}
						onKeyDown={this.onKeyDown}
						placeholder='Digite e pressione Enter'
                    />

                    <ButtonTable
                        type={'success'}
                        icon={'fas fa-plus'}
                        visible={true}
                        event={() => {
                            this.adicionar(this.state.texto)
                        }} />
				</div>

				{this.state.sugestoes.length > 0 && (
					<ul className='list-group' style={{ position: 'absolute', zIndex: 10 }}>
						{this.state.sugestoes.map(s => (
							<li
								key={s}
								className='list-group-item list-group-item-action'
								style={{ cursor: 'pointer' }}
								onClick={() => this.adicionar(s)}
							>
								{s}
							</li>
						))}
					</ul>
				)}

                <div style={{ marginTop: 10 }}>
                    <Table responsive>
                        <TBody>
                            {(lista || []).filter(item => item.ativo).map(item => (
                                <Tr key={item.id}>
                                    <Td>{item.descricao}</Td>
                                    <Td alignRight minWidth={10}>
                                        <ButtonTable
                                            type={'danger'}
                                            icon={'fas fa-trash-alt'}
                                            visible={true}
                                            event={() => {
                                                this.remover(item);
                                            }} />
                                    </Td>
                                </Tr>
                            ))}
                        </TBody>
                    </Table>
                </div>
            </div>
        );
    }
}